// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oGIFhhVZmSprAK {
  display: flex;
  position: relative;
  flex-flow: row;
  justify-content: space-between;
  min-height: 40px;
  padding: var(--ds-space-150, 12px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.oGIFhhVZmSprAK .g04uNid8YsWTiH {
  display: block;
  position: relative;
  z-index: 0;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  margin: var(--ds-space-050, 4px) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  overflow: visible;
  border-radius: 25em;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
  -webkit-user-select: none;
  user-select: none;
}
.oGIFhhVZmSprAK .g04uNid8YsWTiH .mbNFhyhDPTaTYr {
  width: 32px;
  height: 32px;
  border-radius: 25em;
  object-fit: cover;
}
.oGIFhhVZmSprAK .g04uNid8YsWTiH .V2hTffdC_eREAz {
  display: block;
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 32px;
  overflow: hidden;
  font-size: 12px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 32px;
  text-align: center;
}
.oGIFhhVZmSprAK .b2GzlEwqHiqPLN {
  flex: 1;
  width: 160px;
}
.oGIFhhVZmSprAK .b2GzlEwqHiqPLN .QYKUTMS7xfKPCK {
  margin-right: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-0, 0);
  overflow: hidden;
  font-size: 16px;
  font-weight: var(--ds-font-weight-bold, bold);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.oGIFhhVZmSprAK .b2GzlEwqHiqPLN .TLTEgSDicuvHTn {
  margin-bottom: var(--ds-space-0, 0);
  padding-bottom: var(--ds-space-0, 0);
  overflow: hidden;
  color: var(--ds-text-subtle, #44546f);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.oGIFhhVZmSprAK .xk_yGmxUx3JpqI {
  max-height: 32px;
  margin: auto;
  padding-left: var(--ds-space-200, 16px);
}
.oGIFhhVZmSprAK .IzrVDxLa4LQnmN {
  min-width: 95px;
  max-height: 32px;
  margin: var(--ds-space-0, 0);
}
._uHG3pBq0cUrcA {
  display: flex;
  justify-content: center;
  width: 100%;
}
.QXQBsFXbwX536s {
  border-bottom: 1px solid var(--ds-border, #091e4224);
  min-height: 40px;
  padding: var(--ds-space-150, 12px) var(--ds-space-0, 0);
}
.yvCpUAwkI9H6Wn {
  border-top: 1px solid var(--ds-border, #091e4224);
}
.PQQ7dDGCdkmzuw {
  margin-bottom: var(--ds-space-100, 8px);
}
.htf8IacPLWejjV {
  display: flow-root;
  margin-top: var(--ds-space-400, 32px);
}
.htf8IacPLWejjV .PQQ7dDGCdkmzuw {
  float: right;
}
.htf8IacPLWejjV .CArAKRvAzmXGcb {
  max-width: 64px;
}
.htf8IacPLWejjV input {
  margin-bottom: var(--ds-space-0, 0);
}
.nEToz9puLM_309 {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  /* TODO: This can be removed after forms.less is fully removed from Trello */
  /* stylelint-disable-next-line declaration-no-important */
  box-sizing: border-box !important;
  /* stylelint-disable-next-line declaration-no-important */
  width: 100% !important;
  margin-bottom: var(--ds-space-150, 12px);
}
.nEToz9puLM_309:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.nEToz9puLM_309:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.nEToz9puLM_309:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.nEToz9puLM_309[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.nEToz9puLM_309.i55ohescb7BhEm {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.nEToz9puLM_309.i55ohescb7BhEm:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.nEToz9puLM_309.i55ohescb7BhEm:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.nEToz9puLM_309.OG2srPlqUyRK3J {
  width: 100%;
}
.nEToz9puLM_309::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.bTcalSTbeowBEw {
  max-height: 400px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberItem": `oGIFhhVZmSprAK`,
	"memberAvatar": `g04uNid8YsWTiH`,
	"memberImage": `mbNFhyhDPTaTYr`,
	"memberInitials": `V2hTffdC_eREAz`,
	"memberDetails": `b2GzlEwqHiqPLN`,
	"memberFullName": `QYKUTMS7xfKPCK`,
	"memberUsername": `TLTEgSDicuvHTn`,
	"memberOption": `xk_yGmxUx3JpqI`,
	"memberRemoveButton": `IzrVDxLa4LQnmN`,
	"spinnerContainer": `_uHG3pBq0cUrcA`,
	"memberItemSpinner": `QXQBsFXbwX536s`,
	"membersList": `yvCpUAwkI9H6Wn`,
	"addCollaboratorsButton": `PQQ7dDGCdkmzuw`,
	"addCollaboratorsButtonSection": `htf8IacPLWejjV`,
	"addCollaboratorButton": `CArAKRvAzmXGcb`,
	"searchBar": `nEToz9puLM_309`,
	"input-error": `i55ohescb7BhEm`,
	"full": `OG2srPlqUyRK3J`,
	"addCollaboratorsPopoverContent": `bTcalSTbeowBEw`
};
export default ___CSS_LOADER_EXPORT___;
